import { ADD_ARTICLE_LOADER, DELETE_ARTICLE_LOADER, GET_ARTICLE_DATA } from './../action/Articles';

const initialState = {
  addArticleLoader: false,
  ArticlesData: [],
  deleteArticleLoader: false,
};

const ContentReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ARTICLE_LOADER:
      return {
        ...state,
        addArticleLoader: action.payload,
      };
    case GET_ARTICLE_DATA:
      return {
        ...state,
        ArticlesData: action.payload,
      };

    case DELETE_ARTICLE_LOADER:
      return {
        ...state,
        deleteArticleLoader: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};
export default ContentReducer;
